import React from "react";
import { Route, Routes } from "react-router-dom";
import { CredentialVerificationV1 } from "./v1";
import { SectionLayout } from "./v1/section-layout";

interface CredentialVerificationVersionRouterProps {}

export const CredentialVerificationVersionRouter: React.FC<
  CredentialVerificationVersionRouterProps
> = () => {
  return (
    <Routes>
      <Route path="" element={<SectionLayout />} />
      <Route path="v1/*" element={<CredentialVerificationV1 />} />
    </Routes>
  );
};

